import { useContext } from "react"
import { AppContext } from "../App"
import logo_icon from '../assets/logo_icon.png';
import { MdMenu } from "react-icons/md";

export default function TopBar(props) {

  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({
      item,
    })
  }

  return (
    <div
      className="TopBar"
    >
      <div className="body">
        <div
          className="container d-flex justify-content-between"
          style={{
            height: "100%",
          }}
        >
          <div 
            className="align-self-center d-flex"
            style={{
              height: "100%",
              flexShrink: 1,

            }}
          >
            <MdMenu
              className="align-self-center mMobileOnly"
              size={32}
              style={{
                flexShrink: 0,
                cursor: "pointer",
                marginRight: "10px"
              }}
              onClick={appContext.openSideBar}
            />

            <img
              src={logo_icon}
              style={{
                height: "50px",
                width: "auto",
                margin: "0",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mDesktopOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />

            <img
              src={logo_icon}
              style={{
                height: "50px",
                width: "auto",
                margin: "0",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mMobileOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />
          </div>

          <div
            className="DesktopMenu align-self-center mNoMargin mNoPadding"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
              onClick={() => goTo("home")}
              style={{
                color: (appContext.navItem === 'home' || !appContext.navItem) ? "var(--secondaryColor)" : "var(--darkColor)",
                transition: "all 0.4s ease-in",
              }}
            >
              Home
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("about_us")}
              style={{
                color: (appContext.navItem === 'about_us') ? "var(--secondaryColor)" : "var(--darkColor)",
                transition: "all 0.4s ease-in",
              }}
            >
              About Us
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("programs")}
              style={{
                color: (appContext.navItem === 'programs') ? "var(--secondaryColor)" : "var(--darkColor)",
                transition: "all 0.4s ease-in",
              }}
            >
              Programs
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("children")}
              style={{
                color: (appContext.navItem === 'children') ? "var(--secondaryColor)" : "var(--darkColor)",
                transition: "all 0.4s ease-in",
              }}
            >
              Children
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("contact_us")}
              style={{
                color: (appContext.navItem === 'contact_us') ? "var(--secondaryColor)" : "var(--darkColor)",
                transition: "all 0.4s ease-in",
              }}
            >
              Contact Us
            </div>

          </div>

          <div
              className="mDesktopOnly"
              onClick={() => goTo("donations")}
              
            >
              <button
                className="btn btn-secondary font-bold btn-rounded"
                style={{
                  fontSize: "14px"
                }}
              >
                DONATE 
              </button>
          </div>

          <div
            className="align-self-center mNoMargin mNoPadding mMobileOnly"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
            >
              <button
                className="btn btn-secondary font-bold btn-rounded"
                style={{
                  fontSize: "14px"
                }}
                onClick={() => goTo("donations")}
              >
                DONATE
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}